module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"user_display_name_message_html":"<b>%{user_display_name}</b>的評論。","user_grade":"用戶等級","author_grade":"創建者等级"}}')
  delete Component.options._Ctor
}
